import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';

export default function EditToggler(props) {
  const { canRenderEdit, onRedirectToPreferences } = props;
  return canRenderEdit ? (
    <Button type="link" onClick={onRedirectToPreferences} className="e2e-edit-preferences">
      Edit preferences
    </Button>
  ) : null;
}

EditToggler.propTypes = {
  onRedirectToPreferences: PropTypes.func.isRequired,
  canRenderEdit: PropTypes.bool,
};
